export const isTabletOrMobileSize = "(max-width: 1224px)";
export const isMobileSize = "(max-width: 700px)";
